/* global URL_MENU */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import { useGetCommerce } from '@pages/Commerce/hooks/commerce';
import { useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import useTracking, { TRACK_EVENT_NAMES } from '@utils/hooks/useTracking';
import { openExternalUrl } from '@utils/navigationExternalUrl';
import { EXTERNAL_URLS } from '@utils/constants';
import {
  IconBulb,
  IconHelpCircle,
  IconBrandWhatsapp,
  IconChefHat,
  IconUser,
  IconCloudCheck,
  IconLogout,
} from '@tabler/icons-react';

type DesktopMenuItem = {
  label: string;
  icon: React.JSX.Element;
  onClick: () => void;
  color: string;
};

export const useDesktopMenuItems = (): DesktopMenuItem[] => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { commerce } = useGetCommerce();
  const { trackEvent } = useTracking();
  const { isFounder } = useSubscription();

  return [
    {
      label: 'Sugerencias',
      icon: <IconBulb width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.SuggestionsClicked);
        openExternalUrl(EXTERNAL_URLS.IDEAS);
      },
      color: 'inherit',
    },
    {
      label: 'Centro de Ayuda',
      icon: <IconHelpCircle width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.SupportClicked);
        openExternalUrl(EXTERNAL_URLS.HELP_CENTER);
      },
      color: 'inherit',
    },
    {
      label: 'Soporte',
      icon: <IconBrandWhatsapp width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.WhatsAppSupportClicked);
        openExternalUrl(EXTERNAL_URLS.SUPPORT_WHATSAPP);
      },
      color: 'inherit',
    },
    {
      label: 'Ir a mi menú',
      icon: <IconChefHat width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.MenuViewClicked);
        window.open(`${URL_MENU}/${commerce.id_path}`);
      },
      color: 'inherit',
    },
    ...(!isFounder
      ? [
          {
            label: 'Mi cuenta',
            icon: <IconUser width={22} height={22} />,
            onClick: () => {
              trackEvent(TRACK_EVENT_NAMES.MyAccountClicked);
              navigate('mi-cuenta');
            },
            color: 'inherit',
          },
        ]
      : []),
    {
      label: 'Actualizaciones',
      icon: <IconCloudCheck width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.UpdatesClicked);
        openExternalUrl(EXTERNAL_URLS.BLOG_UPDATES);
      },
      color: 'inherit',
    },
    {
      label: 'Cerrar Sesión',
      icon: <IconLogout width={22} height={22} />,
      onClick: () => {
        trackEvent(TRACK_EVENT_NAMES.LogoutClicked);
        auth.logout();
      },
      color: '#FF3939',
    },
  ];
};
